import request from './request';

export const agentCrewAPI = {
  getAgents: () => request.get('/agent-crew/agents'),
  createTask: (data) => request.post('/agent-crew/tasks', data),
  getTask: (taskId) => request.get(`/agent-crew/tasks/${taskId}`),
};

export default agentCrewAPI;
